import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompleteRegister = _resolveComponent("CompleteRegister")!

  return (_openBlock(), _createBlock(_component_CompleteRegister, {
    id: _ctx.id,
    token: _ctx.token
  }, null, 8, ["id", "token"]))
}